import { useAuth } from '../contexts/AuthContext';
import { useLocation } from 'react-router-dom';
import GmailScraper from '../components/GmailScraper';

const logoSrc = `${process.env.PUBLIC_URL}/JAM_logo.png`;

const Home = () => {
    const { user } = useAuth();
    const location = useLocation();
    
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 'calc(100vh - 80px)',
                padding: '2rem',
                textAlign: 'center'
            }}
        >
            <img
                src={logoSrc}
                alt="JAM Logo"
                className="home-page-logo"
            />
            <h1 style={{ marginBottom: '1rem', color: '#333' }}>
                Welcome to your Job Application Manager!
            </h1>
            {user ? (
                <div>
                    <p style={{ fontSize: '1.2rem', color: '#666', marginBottom: '2rem' }}>
                        You're logged in! Start tracking your job applications.
                    </p>
                           <div style={{
                               background: '#e8f5e8',
                               padding: '1rem',
                               borderRadius: '8px',
                               border: '1px solid #039772b0',
                               marginBottom: '2rem'
                           }}>
                               <p>🎉 Google SSO is working perfectly!</p>
                           </div>
                           
                           <div style={{
                               display: 'flex',
                               gap: '1rem',
                               justifyContent: 'center',
                               marginBottom: '2rem',
                               flexWrap: 'wrap'
                           }}>
                               <a 
                                   href="/dashboard" 
                                   style={{
                                       background: 'linear-gradient(135deg, #039772b0, #039772)',
                                       color: 'white',
                                       textDecoration: 'none',
                                       padding: '1rem 2rem',
                                       borderRadius: '8px',
                                       fontWeight: '600',
                                       transition: 'all 0.3s ease'
                                   }}
                                   onMouseOver={(e) => {
                                       e.target.style.transform = 'translateY(-2px)';
                                       e.target.style.boxShadow = '0 6px 20px rgba(3, 151, 114, 0.3)';
                                   }}
                                   onMouseOut={(e) => {
                                       e.target.style.transform = 'translateY(0)';
                                       e.target.style.boxShadow = 'none';
                                   }}
                               >
                                   📊 View Dashboard
                               </a>
                               <a 
                                   href="/add-application" 
                                   style={{
                                       background: 'linear-gradient(135deg, #007bff, #0056b3)',
                                       color: 'white',
                                       textDecoration: 'none',
                                       padding: '1rem 2rem',
                                       borderRadius: '8px',
                                       fontWeight: '600',
                                       transition: 'all 0.3s ease'
                                   }}
                                   onMouseOver={(e) => {
                                       e.target.style.transform = 'translateY(-2px)';
                                       e.target.style.boxShadow = '0 6px 20px rgba(0, 123, 255, 0.3)';
                                   }}
                                   onMouseOut={(e) => {
                                       e.target.style.transform = 'translateY(0)';
                                       e.target.style.boxShadow = 'none';
                                   }}
                               >
                                   ➕ Add Application
                               </a>
                           </div>
                           
                           <GmailScraper triggerScan={location.state?.triggerScan} />
                </div>
            ) : (
                <div>
                    <p style={{ fontSize: '1.2rem', color: '#666', marginBottom: '2rem' }}>
                        Please log in to start tracking your job applications.
                    </p>
                    <p style={{ color: '#999' }}>
                        Use the Google Sign-In button in the top-right corner.
                    </p>
                </div>
            )}
        </div>
    )
}

export default Home;